import { getWeatherSourceDisplayName } from "./colombiaWeatherSourceMetadata.js";

export const COLOMBIA_RAINVIEWER_SOURCE_KEY = "RAINVIEWER_COLOMBIA";
export const COLOMBIA_RAINVIEWER_LAYER_KEY = "CO_RAINVIEWER_RADAR_BACKUP";
export const COLOMBIA_RAINVIEWER_ATTRIBUTION = "Radar data © RainViewer";
export const COLOMBIA_RAINVIEWER_SOURCE_LABEL = getWeatherSourceDisplayName(
  COLOMBIA_RAINVIEWER_SOURCE_KEY,
  "RainViewer Colombia Fallback"
);
export const COLOMBIA_RAINVIEWER_LAYER_LABEL = COLOMBIA_RAINVIEWER_SOURCE_LABEL;
export const COLOMBIA_RAINVIEWER_FALLBACK_WARNING =
  "Showing RainViewer backup because the official IDEAM layer is unavailable or stale.";
export const COLOMBIA_RAINVIEWER_DEFAULT_OPACITY = 0.65;
export const COLOMBIA_RAINVIEWER_ANIMATION_INTERVAL_MS = 700;
